import { keyframes } from '@mui/material';

export const getHighlightAnimationKeyframes = (
  color1: string,
  color2: string,
) => {
  const highlightKeyframes = keyframes`
  0% {
    background-color: ${color1};
  }
  100% {
    background-color: ${color2};
  }
`;

  return highlightKeyframes;
};
